// Muestra "—" cuando el monto no existe / no es numérico (evita "Bs NaN").
export const bsAmount = (v) => {
  if (v === null || v === undefined || v === "") return "—";
  const n = Number(v);
  return Number.isFinite(n) ? Math.round(n) : "—";
};
